
export default {
    name: 'rapport-apport-social',
    components: {},
    props: {
        rapport_apports_sociaux: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient",  { key: 'montant', label: 'Montant' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            apport_sociaux_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshApportSociaux()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshApportSociaux() {
            if (this.rapport_apports_sociaux) {
                this.apport_sociaux_len = this.rapport_apports_sociaux.length
            }
        }
    }
}